export function UploadIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.40039 13.6016C2.40039 13.1597 2.75856 12.8016 3.20039 12.8016H12.8004C13.2422 12.8016 13.6004 13.1597 13.6004 13.6016C13.6004 14.0434 13.2422 14.4016 12.8004 14.4016H3.20039C2.75856 14.4016 2.40039 14.0434 2.40039 13.6016ZM5.03471 5.36725C4.72229 5.05483 4.72229 4.5483 5.03471 4.23588L7.43471 1.83588C7.58473 1.68585 7.78822 1.60156 8.00039 1.60156C8.21256 1.60156 8.41605 1.68585 8.56608 1.83588L10.9661 4.23588C11.2785 4.5483 11.2785 5.05483 10.9661 5.36725C10.6537 5.67967 10.1471 5.67967 9.83471 5.36725L8.80039 4.33293V10.4016C8.80039 10.8434 8.44222 11.2016 8.00039 11.2016C7.55856 11.2016 7.20039 10.8434 7.20039 10.4016L7.20039 4.33293L6.16608 5.36725C5.85366 5.67967 5.34713 5.67967 5.03471 5.36725Z'
        fill='currentColor'
      />
    </svg>
  )
}
